var _style, _g, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 64 64",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:white;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:white;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st2{fill:none;stroke:white;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:6,5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,16c0,1.1-0.5,2.1-1.2,2.8C50.1,19.5,49.1,20,48,20h-2v-4H18v4h-2c-2.2,0-4-1.8-4-4c0-1.1,0.5-2.1,1.2-2.8   c0.7-0.7,1.7-1.2,2.8-1.2h32C50.2,12,52,13.8,52,16z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 48,
    x2: 46,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46,16v36h-7c0-3.9-3.1-7-7-7s-7,3.1-7,7h-7V16H46z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 18,
    x2: 16,
    y1: 16,
    y2: 16
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 18,
    x2: 46,
    y1: 36.8,
    y2: 36.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.b88ecf7b5976ffbf30284b3e05d1a8db.svg";
export { ForwardRef as ReactComponent };